import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../apiconfig";
import "./alert.css";
import logoutUser from "./logoutUser";

function Payment({ onNext, onPrev }) {

	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [alertData, setAlertData] = useState(null);

	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 5000);
	};

	const handlePayment = () => {

		setLoading(true);

		showAlert("Redirecting to payment gateway...", "success");

		setTimeout(() => {
			window.location.href =
				"https://onlinesbi.sbi.bank.in/sbicollect/icollecthome.htm?corpID=880654";
				
		}, 800);
	};

	const [isPaymentDone, setIsPaymentDone] = useState(false);

	useEffect(() => {
		const checkPaymentStatus = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (response.status === 401 || response.status === 403) {

					logoutUser(navigate);
					return;
				}

				if (!response.ok) {
					console.error("Failed to fetch program");
					return;
				}


				if (!response.ok) return;

				const result = await response.json(); // boolean true/false
				console.log("Payment Done:", result);

				setIsPaymentDone(result);

				if (result) {
					showAlert(
						"Payment already completed ✅. Please download the Application Print-Out.",
						"success"
					);

					setTimeout(() => {
						onNext(); // 👉 auto redirect
					}, 1000); // small delay for UX
				}

			} catch (error) {
				console.error("Error checking payment:", error);
			}
		};

		checkPaymentStatus();
	}, []);

	return (
		<>
			<style>{`

		@keyframes smoothEntry {
			0% {
				opacity: 0;
				transform: translateY(20px);
			}
			100% {
				opacity: 1;
				transform: translateY(0);
			}
		}

		.program-container {
			background: #ffffff;
			padding: 20px;
			border-radius: 12px;
			border: 1px solid #e2e8f0;
			font-family: 'Poppins', sans-serif;
			width: 100%;
			max-width: 850px;
			display: flex;
			flex-direction: column;
			animation: smoothEntry 0.4s ease;
		}

		.program-title {
			font-size: 18px;
			font-weight: 600;
			color: #1e3a8a;
			margin-bottom: 10px;
		}

		.program-subtitle {
			font-size: 13px;
			color: #475569;
			margin-bottom: 15px;
		}

		/* Payment Box (same as radio style) */
		.payment-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 14px;
			border: 1px solid #e2e8f0;
			border-radius: 8px;
			background: #f8fafc;
			margin-bottom: 15px;
		}

		.payment-label {
			font-size: 14px;
			color: #1e293b;
			font-weight: 500;
		}

		.payment-amount {
			font-size: 20px;
			font-weight: 700;
			color: #2563eb;
		}

		.footer {
			display: flex;
			justify-content: space-between;
			margin-top: 20px;
		}

		.btn {
			padding: 8px 16px;
			border-radius: 6px;
			border: none;
			cursor: pointer;
			font-size: 13px;
		}

		.prev-btn {
			background: #e2e8f0;
		}

		.next-btn {
			background: #2563eb;
			color: white;
		}

		.next-btn:disabled {
			background: #94a3b8;
			cursor: not-allowed;
		}

		.secure-text {
			text-align: center;
			font-size: 12px;
			color: #64748b;
			margin-top: 10px;
		}

		/* 📱 Mobile */
		@media (max-width: 768px) {

			.program-container {
				padding: 15px;
				max-width: 100%;
			}

			.program-title {
				font-size: 16px;
				text-align: center;
			}

			.program-subtitle {
				font-size: 12px;
				text-align: center;
			}

			.payment-box {
				flex-direction: column;
				gap: 10px;
				text-align: center;
			}

			.footer {
				flex-direction: column;
				gap: 10px;
			}

			.btn {
				width: 100%;
				padding: 10px;
				font-size: 14px;
			}
		}

		`}</style>

			{/* Alert */}
			{alertData && (
				<div className={`custom-alert ${alertData.type}`}>
					<span className="alert-icon">
						{alertData.type === "success" ? "✔" : "❗"}
					</span>
					{alertData.message}
				</div>
			)}

			<div className="program-container">

				<div className="program-title">Online Payment</div>

				{!isPaymentDone ? (
					<>
						<div className="program-subtitle">
							Complete your application by paying the fee
						</div>

						<div className="payment-box">
							<span className="payment-label">Application Fee</span>
							<span className="payment-amount">₹2000</span>
						</div>

						<button
							className="btn next-btn"
							onClick={handlePayment}
							disabled={loading}
						>
							{loading ? "Processing..." : "Make Online Payment"}
						</button>

						<p className="secure-text">
							🔒 After Making online Payment, Payment status will be Successful within 2 or 3 days of bank verification.
						</p>
					</>
				) : (
					<>
						<div className="program-subtitle" style={{ textAlign: "center", color: "#16a34a", fontWeight: "500" }}>
							✅ Payment Completed Successfully
						</div>

						<div className="payment-box" style={{ justifyContent: "center" }}>
							<span className="payment-label">Your payment has been verified</span>
						</div>


					</>
				)}

				{/* Footer */}
				<div className="footer">

					<button className="btn prev-btn" onClick={onPrev}>
						⬅ Previous
					</button>


				</div>

			</div>
		</>
	);
}

export default Payment;